import React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Link } from "react-router-dom";

import Spinner from "../app/Spinner";
import Modal from "../app/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faPen,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";

import RecordEdit from "./RecordEdit";
import RecordDelete from "./RecordDelete";

import "./MenuEdit.css";
import "./ProductList.css";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      form: null,
      modalOpen: false,
      selected: [],
      user: this.props.auth.googleId
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
  }

  componentDidMount() {
    this.props.fetchUser();
    this.props.fetchColors();
    this.props.fetchBrands(localStorage.getItem("SubscriptionId"));
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.props.fetchBrands(localStorage.getItem("SubscriptionId"));
  };

  render() {
    const RenderPlaceholder = () => {
      return <Spinner />;
    };
    const RenderContent = props => {
      return (
        <div>
          <Link className="waves-effect waves-light btn" to="/menus/config">
            <FontAwesomeIcon icon={faChevronLeft} size="lg" /> Back to
            Configuration
          </Link>
          <div className="component-group">
            <h1>Brand Manager</h1>
            <div className="panel-container component-shadow">
              <div className="panel-header">
                <div className="panel-title">Brands</div>
                <div className="panel-actions">
                  <button
                    className="waves-effect waves-light btn btn-small"
                    onMouseDown={handleAddRecord}
                  >
                    <FontAwesomeIcon icon={faPlus} size="lg" /> Add Brand
                  </button>
                </div>
              </div>
              <div className="panel-content">{renderList()}</div>
            </div>
          </div>
        </div>
      );
    };

    // ***************************
    // RENDER RESULTS
    const renderList = () => {
      if (this.props.brands) {
        return this.props.brands.map((record, index) => {
          let deleteButton = "";
          if (localStorage.getItem("UserIsAdmin") === "true") {
            deleteButton = (
              <button
                className="waves-effect waves-light btn btn-small"
                onMouseDown={handleDeleteRecord}
                id={index}
              >
                <FontAwesomeIcon icon={faTrash} size="lg" />
              </button>
            );
          }
          let itemStyle = {
            borderLeft: "4px solid rgba(255,255,255,.5)"
          };
          if (record.ColorCode) {
            itemStyle = {
              borderLeft:
                "4px solid rgba(" + record.ColorCode.ColorCode + ",.5)"
            };
          }
          let textStyle = [];
          if (record.ColorCode && record.ColorCode.Oid !== 1) {
            textStyle = {
              color: "rgba(" + record.ColorCode.ColorCode + ",1)"
            };
          }
          return (
            <div
              key={"sort-" + index}
              value={record.Oid}
              className="item"
              style={itemStyle}
            >
              <div className="item-details">
                <div className="item-name" style={textStyle}>
                  {record.Name}
                </div>
              </div>
              <div className="panel-actions">
                <button
                  className="waves-effect waves-light btn btn-small"
                  onMouseDown={handleEditRecord}
                  id={index}
                >
                  <FontAwesomeIcon icon={faPen} size="lg" />
                </button>
                &nbsp;
                {deleteButton}
              </div>
            </div>
          );
        });
      }
    };

    // ***************************
    // ADD RECORD FUNCTIONALITY
    const handleAddRecord = () => {
      this.setState({
        form: "add-record",
        modalOpen: true
      });
    };

    // ***************************
    // EDIT RECORD FUNCTIONALITY
    const handleEditRecord = e => {
      this.setState({
        form: "edit-record",
        modalOpen: true,
        selected: this.props.brands[e.currentTarget.id]
      });
    };

    // ***************************
    // DELETE RECORD FUNCTIONALITY
    const handleDeleteRecord = e => {
      this.setState({
        form: "delete-record",
        modalOpen: true,
        selected: this.props.brands[e.currentTarget.id]
      });
    };

    const renderForm = type => {
      switch (type) {
        case "add-record":
          return (
            <div>
              <RecordEdit
                id=""
                data=""
                colors={this.props.colors}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
                ReferenceTable="Brand"
              />
            </div>
          );
        case "edit-record":
          return (
            <div>
              <RecordEdit
                id={this.state.selected.Oid}
                data={this.state.selected}
                colors={this.props.colors}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
                ReferenceTable="Brand"
              />
            </div>
          );
        case "delete-record":
          return (
            <div>
              <RecordDelete
                id={this.state.selected.Oid}
                data={this.state.selected}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
                SubscriptionId={localStorage.getItem("SubscriptionId")}
                ReferenceTable="Brand"
              />
            </div>
          );
        default:
          return RenderPlaceholder();
      }
    };

    return (
      <div className="component-group-edit pad-20">
        {this.state.isLoading ? (
          <RenderPlaceholder />
        ) : (
          <RenderContent title="Brands" />
        )}
        <Modal modalOpen={this.state.modalOpen}>
          {renderForm(this.state.form, this.state.groupData)}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    brands: state.brands,
    colors: state.colors
  };
}

export default connect(
  mapStateToProps,
  actions
)(Component);
